import { Component, OnInit } from '@angular/core';
import { BoardService } from 'src/app/_provider/boards/board.service';
import { StorageManagerService } from 'src/app/_provider/storage-manager.service';

export interface BoardCardView{
  name: string
  active: boolean
}

@Component({
  selector: 'app-board-card-view-editor',
  templateUrl: './board-card-view-editor.component.html',
  styleUrls: ['./board-card-view-editor.component.scss', '../board-select.scss'],
})
export class BoardCardViewEditorComponent {

  public cardView: BoardCardView[] = []
  public viewChanged: (data: BoardCardView[]) => void

  constructor(
    public boardSrv: BoardService
  ) {
  
  }

  public async toggle(item: BoardCardView){
    item.active = !item.active
    this.viewChanged(this.cardView)
  }

}
